module.exports = __webpack_public_path__ + "static/media/carrot-email.a6cf9af2.svg";